import React from "react"

export default ({ name, selector, attribute = "color" } = {}) => ({
  name,
  type: "color",
  component: ({ name: _name, value, onChange }) => {
    return (
      <div>
        <input value={value} onChange={onChange} />
      </div>
    )
  },
  css: value => {
    return `
      ${selector} {
        ${attribute}: ${value};
      }
    `
  }
})
